import React, { useState, useEffect, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box,
    Card,
    Button,
    makeStyles,
    Container,
    Divider,
    CardContent,
    CardHeader,
    Grid,
    TextField,
    MenuItem,
    InputLabel
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import MaterialTable from "material-table";
import xlsx from 'json-as-xlsx';
import { LoadingComponent } from 'src/utils/newLoader';
import { useAlert } from "react-alert";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    row: {
        marginTop: '1rem'
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecordAndNew: {
        backgroundColor: "#FFBE00"
    },
    colorRecord: {
        backgroundColor: "green",
    }
}));

const screenCode = 'AMENDMENTAUDITREPORT';

export default function AmendmentAuditReport(props) {
    const [title, setTitle] = useState("Leaf Amendment Audit Report")
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [routes, setRoutes] = useState();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [amendmentAuditReportData, setAmendmentAuditReportData] = useState([]);
    const [amendmentAuditReportList, setAmendmentAuditReportList] = useState({
        groupID: '0',
        factoryID: '0',
        routeID: 0,
        month: '',
        year: ''
    })

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        factoryName: "0",
        routeName: "0",
        groupName: "0",
        month: '',
        year: ''
    })

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [csvHeaders, SetCsvHeaders] = useState([])
    const componentRef = useRef();
    const navigate = useNavigate();
    const alert = useAlert();

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermission());
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropDown());
        setAmendmentAuditReportData([]);
    }, [amendmentAuditReportList.groupID]);

    useEffect(() => {
        trackPromise(
            getRoutesByFactoryID()
        );
        setAmendmentAuditReportData([]);
    }, [amendmentAuditReportList.factoryID]);

    useEffect(() => {
        setAmendmentAuditReportData([]);
    }, [amendmentAuditReportList.routeID]);

    useEffect(() => {
        setAmendmentAuditReportData([]);
    }, [selectedDate]);

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWAMENDMENTAUDITREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setAmendmentAuditReportList({
            ...amendmentAuditReportList,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        })
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropDown() {
        const factory = await services.getFactoryByGroupID(amendmentAuditReportList.groupID);
        setFactories(factory);
    }

    async function getRoutesByFactoryID() {
        const route = await services.getRoutesForDropDown(amendmentAuditReportList.factoryID);
        setRoutes(route);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function handleDateChange(date) {
        var month = date.getUTCMonth() + 1; //months from 1-12
        var year = date.getUTCFullYear();
        var currentmonth = moment().format('MM');
        setAmendmentAuditReportList({
            ...amendmentAuditReportList,
            month: month.toString(),
            year: year.toString()
        });

        if (selectedDate != null) {
            var prevMonth = selectedDate.getUTCMonth() + 1
            var prevyear = selectedDate.getUTCFullYear();

            if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
                setSelectedDate(date)
            }
        } else {
            setSelectedDate(date)
        }
    }

    async function GetDetails() {
        let model = {
            groupID: parseInt(amendmentAuditReportList.groupID),
            factoryID: parseInt(amendmentAuditReportList.factoryID),
            routeID: parseInt(amendmentAuditReportList.routeID),
            applicableMonth: moment(selectedDate).format('MM'),
            applicableYear: moment(selectedDate).format('YYYY')
        }
        getSelectedDropdownValuesForReport(model);

        const GetAmendmentData = await services.GetAmendmentAuditDetails(model);

        if (GetAmendmentData.statusCode == "Success" && GetAmendmentData.data != null) {
            setAmendmentAuditReportData(GetAmendmentData.data);
            createDataForExcel(GetAmendmentData.data);

            if (GetAmendmentData.data.length == 0) {
                alert.error("No records to display");
            }
        }
        else {
            alert.error(GetAmendmentData.message);
        }
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Entry No': x.entryNo,
                    'Collection Type': x.collectionType,
                    'Collected Date': x.collectedDate.split('T')[0],
                    'Type of Change': x.typeOfChange == true ? 'Modified' : 'Deleted',
                    'Amended By': x.amendedBy,
                    'Amended Date': x.amendedDate.split('T')[0],
                    'Original Weight': x.typeOfChange == true || x.originalNetWeight != 0 ? x.originalNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : x.amendedWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Amended Weight': x.typeOfChange == true || x.originalNetWeight != 0 ? x.amendedWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : x.originalNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Deference': x.deference > 0 ? x.deference.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (Math.abs(x.deference)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                }
                res.push(vr);
            });

            res.push({});

            var vr1 = {
                'Entry No': 'Group :' + selectedSearchValues.groupName,
                'Collection Type': 'Factory :' + selectedSearchValues.factoryName,
            }
            res.push(vr1);

            var vr2 = {
                'Entry No': 'Year :' + selectedSearchValues.year,
                'Collection Type': 'Month :' + selectedSearchValues.month
            }
            res.push(vr2);

            var vr3 = {
                'Entry No': selectedSearchValues.routeName == undefined ? 'Route :' + 'All Routes' : 'Route :' + selectedSearchValues.routeName,
            }
            res.push(vr3);
        }
        return res;
    }

    async function createFile() {

        var file = await createDataForExcel(amendmentAuditReportData);
        var settings = {
            sheetName: 'Amendment Audit Report',
            fileName: 'Amendment Audit Report' + " - " +
                selectedSearchValues.groupName + " - " +
                selectedSearchValues.factoryName + " - " +
                (selectedSearchValues.routeName == undefined ? "All Routes" : selectedSearchValues.routeName) + " - " +
                selectedSearchValues.month + "/" +
                selectedSearchValues.year,
            writeOptions: {}
        }

        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })

        let dataA = [
            {
                sheet: 'Amendment Audit Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        )
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setAmendmentAuditReportList({
            ...amendmentAuditReportList,
            [e.target.name]: value
        });
    }

    function getSelectedDropdownValuesForReport(model) {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let monthName = months[(moment(model.applicableMonth).format('MM')) - 1]
        setSelectedSearchValues({
            groupName: groups[model.groupID],
            factoryName: factories[model.factoryID],
            routeName: routes[model.routeID],
            month: monthName,
            year: model.applicableYear
        })
    }

    const getPageMargins = () => {
        return `@media print {
            @page {
                background-color: white !important;
            }
       
            body {
                background-color: white !important;
            }
        }`;
    };

    return (
        <Page className={classes.root} title={title}>
            <LoadingComponent />
            <Container maxWidth={false}>
                <Formik
                    initialValues={{
                        groupID: amendmentAuditReportList.groupID,
                        factoryID: amendmentAuditReportList.factoryID
                    }}
                    validationSchema={
                        Yup.object().shape({
                            groupID: Yup.number().required('Group required').min("1", 'Group required'),
                            factoryID: Yup.number().required('Factory required').min("1", 'Factory required')
                        })
                    }
                    onSubmit={() => trackPromise(GetDetails())}
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <Box mt={0}>
                                <Card>
                                    <CardHeader
                                        title={cardTitle(title)}
                                    />
                                    <PerfectScrollbar>
                                        <Divider />
                                        <CardContent>
                                            <Grid container spacing={3}>
                                                <Grid item md={3} xs={8}>
                                                    <InputLabel shrink id="groupID">
                                                        Group *
                                                    </InputLabel>
                                                    <TextField select
                                                        error={Boolean(touched.groupID && errors.groupID)}
                                                        fullWidth
                                                        helperText={touched.groupID && errors.groupID}
                                                        name="groupID"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => handleChange(e)}
                                                        value={amendmentAuditReportList.groupID}
                                                        variant="outlined"
                                                        id="groupID"
                                                        size='small'
                                                    >
                                                        <MenuItem value="0">--Select Group--</MenuItem>
                                                        {generateDropDownMenu(groups)}
                                                    </TextField>
                                                </Grid>

                                                <Grid item md={3} xs={8}>
                                                    <InputLabel shrink id="factoryID">
                                                        Factory *
                                                    </InputLabel>
                                                    <TextField select
                                                        error={Boolean(touched.factoryID && errors.factoryID)}
                                                        fullWidth
                                                        helperText={touched.factoryID && errors.factoryID}
                                                        name="factoryID"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => handleChange(e)}
                                                        value={amendmentAuditReportList.factoryID}
                                                        variant="outlined"
                                                        id="factoryID"
                                                        size='small'
                                                    >
                                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                                        {generateDropDownMenu(factories)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={8}>
                                                    <InputLabel shrink id="routeID">
                                                        Route
                                                    </InputLabel>
                                                    <TextField select
                                                        fullWidth
                                                        name="routeID"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => handleChange(e)}
                                                        value={amendmentAuditReportList.routeID}
                                                        variant="outlined"
                                                        id="routeID"
                                                        size='small'
                                                    >
                                                        <MenuItem value="0">--Select Routes--</MenuItem>
                                                        {generateDropDownMenu(routes)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={8}>
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <DatePicker
                                                            autoOk
                                                            variant="inline"
                                                            openTo="month"
                                                            views={["year", "month"]}
                                                            label="Year and Month *"
                                                            helperText="Select applicable month"
                                                            value={selectedDate}
                                                            disableFuture={true}
                                                            onChange={(date) => handleDateChange(date)}
                                                            size='small'
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Grid>
                                            </Grid>
                                            <Box display="flex" flexDirection="row-reverse" p={2} >
                                                <Button
                                                    color="primary"
                                                    type="submit"
                                                    variant="contained"
                                                >
                                                    Search
                                                </Button>
                                            </Box>
                                            <br />
                                            <Box minWidth={1050}>
                                                {amendmentAuditReportData.length > 0 ?
                                                    <MaterialTable
                                                        title="Multiple Actions Preview"
                                                        columns={[
                                                            { title: 'Entry No', field: 'entryNo' },
                                                            { title: 'Collection Type', field: 'collectionType' },
                                                            {
                                                                title: 'Collected Date',
                                                                field: 'collectedDate',
                                                                render: rowData => rowData.collectedDate.split('T')[0],
                                                            },
                                                            {
                                                                title: 'Type of change',
                                                                field: 'typeOfChange',
                                                                render: rowData => rowData.typeOfChange == true ? 'Modified' : 'Deleted',
                                                            },
                                                            { title: 'Amended By', field: 'amendedBy' },
                                                            {
                                                                title: 'Amended Date',
                                                                field: 'amendedDate',
                                                                render: rowData => rowData.amendedDate.split('T')[0],
                                                            },
                                                            {
                                                                title: 'Original Weight',
                                                                field: 'originalNetWeight',
                                                                render: rowData => {
                                                                    const tempOriginalNetWeight = rowData.originalNetWeight;
                                                                    const tempAmendedWeight = rowData.amendedWeight;
                                                                    const tempTypeOfChange = rowData.typeOfChange;
                                                                    return (tempTypeOfChange == true || tempOriginalNetWeight != 0 ? tempOriginalNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                        : tempAmendedWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
                                                                },
                                                                cellStyle: { textAlign: "right", paddingRight: '4%' }
                                                            },
                                                            {
                                                                title: 'Amended Weight',
                                                                field: 'amendedWeight',
                                                                render: rowData => {
                                                                    const tempOriginalNetWeight = rowData.originalNetWeight;
                                                                    const tempAmendedWeight = rowData.amendedWeight;
                                                                    const tempTypeOfChange = rowData.typeOfChange;
                                                                    return (tempTypeOfChange == true || tempOriginalNetWeight != 0 ? tempAmendedWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                        : tempOriginalNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
                                                                },
                                                                cellStyle: { textAlign: "right", paddingRight: '4%' }
                                                            },
                                                            {
                                                                title: 'Deference',
                                                                field: 'deference',
                                                                render: rowData => {
                                                                    const tempValue = rowData.deference;
                                                                    return (tempValue > 0 ? tempValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                        : (Math.abs(tempValue)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
                                                                },
                                                                cellStyle: { textAlign: "right", paddingRight: '4%' }
                                                            }
                                                        ]}
                                                        data={amendmentAuditReportData}
                                                        options={{
                                                            exportButton: false,
                                                            showTitle: false,
                                                            headerStyle: { textAlign: "left", height: '1%' },
                                                            cellStyle: { textAlign: "left" },
                                                            columnResizable: false,
                                                            actionsColumnIndex: -1,
                                                            pageSize: 5,
                                                            search: false
                                                        }}
                                                        actions={[

                                                        ]}
                                                    /> : null}
                                            </Box>
                                        </CardContent>

                                        {amendmentAuditReportData.length > 0 ?
                                            <Box display="flex" justifyContent="flex-end" p={2}>
                                                <Button
                                                    color="primary"
                                                    id="btnRecord"
                                                    type="submit"
                                                    variant="contained"
                                                    style={{ marginRight: '1rem' }}
                                                    className={classes.colorRecord}
                                                    onClick={createFile}
                                                >
                                                    EXCEL
                                                </Button>
                                                <div>&nbsp;</div>
                                                <ReactToPrint
                                                    documentTitle={"Amendment Audit Report" + " - " +
                                                        selectedSearchValues.groupName + " - " +
                                                        selectedSearchValues.factoryName + " - " +
                                                        (selectedSearchValues.routeName == undefined ? "All Routes" : selectedSearchValues.routeName) + " - " +
                                                        selectedSearchValues.month + "/" +
                                                        selectedSearchValues.year}
                                                    trigger={() => <Button
                                                        color="primary"
                                                        id="btnCancel"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        className={classes.colorCancel}
                                                    >
                                                        PDF
                                                    </Button>}
                                                    pageStyle={getPageMargins()}
                                                    content={() => componentRef.current}
                                                />
                                                <div hidden={true}>
                                                    <CreatePDF ref={componentRef} amendmentAuditReportList={amendmentAuditReportList}
                                                        AmendmentAuditSearchData={selectedSearchValues} amendmentAuditReportData={amendmentAuditReportData} />
                                                </div>
                                            </Box> : null}
                                    </PerfectScrollbar>
                                </Card>
                            </Box>
                        </form>
                    )}
                </Formik>
            </Container>
        </Page>
    )


}